export const LIVEVIEW_CAMERA_DRAG_TYPE = "application/x-liveview-camera";
const LIVEVIEW_CAMERA_DRAG_PLAIN_PREFIX = "liveview-camera:";

export function setCameraDragData(event, camera, { sourceSlotIndex } = {}) {
  if (!camera?.id) return;
  const payload = JSON.stringify({
    id: camera.id,
    name: camera.name ?? camera.id,
    sourceSlotIndex:
      sourceSlotIndex === undefined || sourceSlotIndex === null
        ? null
        : sourceSlotIndex,
  });
  event.dataTransfer.setData(LIVEVIEW_CAMERA_DRAG_TYPE, payload);
  // Fallback for browsers that only expose text/plain during dragover
  event.dataTransfer.setData(
    "text/plain",
    `${LIVEVIEW_CAMERA_DRAG_PLAIN_PREFIX}${payload}`
  );
  event.dataTransfer.effectAllowed = "copyMove";
}

export function getCameraDragData(event) {
  let raw = event.dataTransfer.getData(LIVEVIEW_CAMERA_DRAG_TYPE);
  if (!raw) {
    const plain = event.dataTransfer.getData("text/plain");
    if (plain?.startsWith(LIVEVIEW_CAMERA_DRAG_PLAIN_PREFIX)) {
      raw = plain.slice(LIVEVIEW_CAMERA_DRAG_PLAIN_PREFIX.length);
    }
  }
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function isCameraDragEvent(event) {
  const types = Array.from(event.dataTransfer?.types ?? []);
  return (
    types.includes(LIVEVIEW_CAMERA_DRAG_TYPE) ||
    types.includes("text/plain")
  );
}
